import { AppState } from '../types/store';

export const getOrders = (state: AppState) => state?.account?.orders ?? [];

export const getSalesFetchParams = (state: AppState) =>
  state?.salesPage?.fetchParams || {};
